import { mutatorAction } from 'satcheljs';
import { getUserConfiguration } from 'owa-session-store';
var assign = require('object-assign');
export default mutatorAction('updateUserOptions', function updateUserOptions(newUserOptions) {
    assign(getUserConfiguration().UserOptions, newUserOptions);
});
//# sourceMappingURL=updateUserOptions.js.map